import { selfAxios } from "@oppein/op-utils";
/**
 * 更新取号标签(权限)
 */
export async function updateByOrgPermissions(params) {
  const { data } = await selfAxios.post(
    "/designordercenter/customerMainContactLabel/updateByOrgPermissions",
    params,
  );
  return data;
}



// WEBPACK FOOTER //
// ./src/api/designordercenter/customerMainContactLabel/updateByOrgPermissions/post.js